import React from "react";
import { useTranslation } from "react-i18next";

export default function Terms() {
    const { t } = useTranslation();

    return (
        <div className="container py-5 mb-5" style={{ minHeight: "60vh" }}>
            <div className="card border-0 shadow-sm p-4 p-md-5">
                <h2 className="fw-bold text-primary mb-4">
                    <i className="bi bi-file-earmark-text me-2"></i>
                    {t("footer_pol_terms")}
                </h2>
                <div className="text-muted lh-lg">
                    <h5 className="fw-bold text-dark mt-4">{t("terms_1_title")}</h5>
                    <p>{t("terms_1_desc")}</p>
                    
                    <h5 className="fw-bold text-dark mt-4">{t("terms_2_title")}</h5>
                    <p>{t("terms_2_desc")}</p>
                    
                    <h5 className="fw-bold text-dark mt-4">{t("terms_3_title")}</h5>
                    <p>{t("terms_3_desc")}</p>

                    <h5 className="fw-bold text-dark mt-4">{t("terms_4_title")}</h5>
                    <p>{t("terms_4_desc")}</p>
                </div>
            </div>
        </div>
    );
}